import { ProgramWizardMessagesStore } from './ProgramWizardMessagesStore';
import { StepInfo } from '../step-wizard/types';
import {
  ProgramDataType,
  AppUserProfile,
  EmptyResponse,
} from '@ssar-app/domain';
import { ReactNode } from 'react';

export type ProgramWizardSaveProps = {
  draftId: string;
  programId: string;
  error: string;
};

export enum ProgramWizardMessageId {
  AutoSaveWarning,
  CloneProgramWarning,
  ClientContactNotExist,
  DeprecatedLookupsExist,
  OutputLocationContactsAreSame,
  OutputContactNotExist,
}

export type ProgramWizardMessage = {
  id: ProgramWizardMessageId;
  type: 'error' | 'warning' | 'info';
  message: ReactNode;
};

export type ProgramWizardStepInfo = StepInfo['step'] & {
  key: string[];
};

export type ProgramWizardConfig = {
  preTransformer: ProgramTransformer;
  steps: ProgramWizardStepInfo[];
  isSaveDraftsAllowed: boolean;
  isAutoSaveAllowed: boolean;
  autoSaveTimer: number;
};

export type ProgramWizardMetadata = {
  isDraft: boolean;
  draftId?: string;
  isClone: boolean;
  from?: string;
};

export type ProgramTransformerArgs = {
  program: Partial<ProgramDataType> | null;
  originalProgram: Partial<ProgramDataType> | null;
  userProfile: AppUserProfile;
  programWizardMetadata: ProgramWizardMetadata;
  messagesStore: ProgramWizardMessagesStore;
  programWizardDependentData: EmptyResponse;
};

export type ProgramTransformer = (
  args: ProgramTransformerArgs,
) => Promise<ProgramTransformerArgs>;
